import { NewsApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { NewsDetail, NewsTableItem } from '@/types/news';
import { TableState } from '@tanstack/react-table';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { GetAllNewsRequest, GetAllNewsResponse } from '@/types/http-payload/news';

export default class NewsStore extends BaseStore {
    api: NewsApi;
    newsList: NewsTableItem[] = [];
    newsDetail: NewsDetail | null = null;
    totalByStatus: Object = {};

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            newsList: observable,
            newsDetail: observable,
            totalByStatus: observable,
            getAllNews: flow.bound,
            getNewsDetail: flow.bound,
            updateNews: flow.bound,
            updateNewsStatus: flow.bound,
            deleteNews: flow.bound,
            createNews: flow.bound
        });
        this.api = new NewsApi();
    }

    *getAllNews(searchParams?: GetAllNewsRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<GetAllNewsResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getAllNews, payload);
            if (res?.ok) {
                this.newsList = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.pagination)
                };
                this.totalRecord = res.data.pagination.totalRecord;
                this.totalByStatus = res.data.totalByStatus;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getNewsDetail(code: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getNewsDetail, code);
            if (res.ok) {
                this.newsDetail = res.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *updateNews(code: string, data: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateNews, { code, data });
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *updateNewsStatus(payload) {
        try {
            // const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateNewsStatus, payload);
            // if (res.ok) {
            //     return res;
            // }
            const res: ResponseData = {
                ok: true,
                message: 'success',
                data: {}
            };
            return res;
        } catch (error) {
            console.log(error);
        }
    }

    *deleteNews(code: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteNews, code);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *createNews(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.createNews, payload);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    clean(): void {
        super.clean();
        this.newsList = [];
    }
}
